module.exports = __webpack_public_path__ + "static/img/cjwt3.a6da605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cjwt3.jpg
// module id = YAhi
// module chunks = 1